import get from 'lodash/get';

export interface DynamicComponentProps {
  _componentTypes: Record<string, any>;
  _defaultComponent?: any;
  _field?: string;
  [key: string]: any;
}

const DynamicComponent = ({
  _componentTypes,
  _defaultComponent = () => null,
  _field = '_meta.schema',
  ...props
}: DynamicComponentProps) => {
  const Component =
    _componentTypes[get(props, _field)] || _componentTypes['default'] || _defaultComponent;
  return <Component {...props} />;
};

export default DynamicComponent;
